<template>
  <!-- <template v-if="state.isLoading || paymentStore.isLoading || paymentStore.isLoadingHistory"> -->
        <!-- Индикатор загрузки для обновления данных -->
    <!-- <div class="home-page__loading">
        <Loader />
    </div> -->
  <!-- </template> -->

    <div
      :class="[
        'home-page',
        { 'home-page--with-banner': shouldShowTelegramSecurityCta }
      ]"
    >
      <!-- Тестовый компонент Sentry и отладочная информация -->
      <!-- <div v-if="isDev" class="debug-info">
        <div class="version-info">
          <h4>📦 Version: {{ versionInfo.formatted }}</h4>
        </div>
        <div class="env-debug">
          <h4>🔍 Environment Debug:</h4>
          <p><strong>VITE_SENTRY_ENABLED:</strong> {{ envDebug.VITE_SENTRY_ENABLED || 'undefined' }}</p>
          <p><strong>VITE_SENTRY_DSN:</strong> {{ envDebug.VITE_SENTRY_DSN ? '✅ SET' : '❌ NOT SET' }}</p>
          <p><strong>VITE_SENTRY_ENVIRONMENT:</strong> {{ envDebug.VITE_SENTRY_ENVIRONMENT || 'undefined' }}</p>
          <p><strong>MODE:</strong> {{ envDebug.MODE }}</p>
          <p><strong>DEV:</strong> {{ envDebug.DEV }}</p>
          <p><strong>PROD:</strong> {{ envDebug.PROD }}</p>
        </div>
        <SentryTest />
      </div> -->
      <div class="home-page-wrapper">
          <div class="home-page__logo">
              <!-- Логотип -->
               <MainLogo class="home-page__logo-main"/>
               <CircleSmall class="home-page__logo-circle-small"/>
               <CircleMedium class="home-page__logo-circle-medium"/>
               <CircleBig class="home-page__logo-circle-big"/>
          </div>
          <div
              v-if="shouldShowTelegramSecurityCta"
              class="home-page__security-banner"
              role="button"
              tabindex="0"
              @click="openCredentialsSetup"
              @keydown.enter.prevent="openCredentialsSetup"
              @keydown.space.prevent="openCredentialsSetup"
          >
              <span class="home-page__security-banner-icon">🔒</span>
              <div class="home-page__security-banner-texts">
                  <span class="home-page__security-banner-title">Не потеряй доступ к VPN!</span>
                  <span class="home-page__security-banner-subtitle">Создайте логин и пароль для входа через браузер.</span>
              </div>
              <span class="home-page__security-banner-action">Настроить</span>
          </div>
          <div class="home-page__user user-block">
              <div class="user-block__row name-traffic">
                  <span class="name-traffic__name">{{ state.user?.username }}</span>
                  <span class="name-traffic__traffic">{{ state.subscription?.is_active ? 'online' : 'offline' }}{{ displayTraffic }}</span>
              </div>
              <div class="user-block__row expired-subtitle">
                  <span class="expired-subtitle__expired" v-if="state.subscription && Object.keys(state.subscription) && state.subscription.exp_date">до {{ formatDateToRussian(new Date(state.subscription.exp_date)) }}</span>
                  <span class="expired-subtitle__subtitle">{{ state.subscription?.is_test ? 'Пробный период' : ''}}</span>
              </div>
          </div>
          <div class="home-page__menu menu-home-page">
              <BaseButton 
                  class="menu-home-page__wallet" 
                  text="Купить подписку" 
                  styles="primary-gradient" 
                  icon="WalletBlack"
                  :subtitile="`от ${String(minPriceValue)} руб.`"
                  subtitle-style="medium"
                  vibration="success"
                  @on-submit="goToPayment"
              />
              
              <BaseButton 
                  class="menu-home-page__setup" 
                  text="Установка и настройка" 
                  styles="secondary-200" 
                  icon="Gear"
                  :subtitile="currentOS"
                  subtitle-style="regular"
                  vibration="button"
                  :is-disabled="!state.subscription || state.subscription.server.protocol !== 'xray'"
                  @on-submit="goToSetup"
              />
              
              <BaseButton 
                  class="menu-home-page__referral" 
                  text="Реферальная программа" 
                  styles="secondary-200" 
                  icon="Referal"
                  vibration="button"
                  :is-disabled="false"
                  @on-submit="openReferral"
              />
              
              <div class="menu-home-page__bottom-row">
                  <BaseButton
                      @on-submit="toMySubscriptions"
                      class="menu-home-page__subscription" 
                      text="Мои подписки" 
                      styles="secondary-200" 
                      icon="User"
                      vibration="button"
                      :is-disabled="false"
                  />
                  
                  <BaseButton 
                      class="menu-home-page__support" 
                      text="Поддержка" 
                      styles="secondary-200" 
                      icon="Message"
                      vibration="button"
                      :is-disabled="false"
                      @on-submit="createSupportTicket"
                  />
              </div>
          <div
              v-if="shouldShowBrowserAuthActions"
              class="menu-home-page__auth-row"
          >
              <BaseButton
                  class="menu-home-page__password" 
                  text="Сменить пароль" 
                  styles="secondary-200" 
                  vibration="button"
                  :is-disabled="false"
                  @on-submit="openPasswordChange"
              />
              
              <BaseButton 
                  class="menu-home-page__logout" 
                  text="Выйти из системы" 
                  styles="secondary-200" 
                  vibration="button"
                  :is-disabled="false"
                  @on-submit="handleLogout"
              />
          </div>
          </div>
      </div>
    </div>
    
    <!-- Компонент для тестирования вибрации -->
    <!-- <VibrationTest /> -->
</template>

<script lang="ts" setup>
import MainLogo from '@/assets/icons/vpnnp-logo.svg'
import { useSubscriptionStore } from '@/entities/Subscription/model/subscriptionStore';
import type { Subscription } from '@/entities/Subscription/model/types';
import type { UserInfo } from '@/entities/User/model/types';
import { useUserStore } from '@/stores/useUser';
import { computed, reactive, type ComputedRef, onMounted, onActivated } from 'vue';
import { formatDateToRussian } from '@/shared/utils/date/formatDateToRussian'
import { parseTraffic } from '@/shared/utils/traffic/parseTraffic';
import { detectOS } from '@/shared/utils/system/detectOS';
import BaseButton from '@/ui/components/Base/BaseButton.vue';
import VibrationTest from '@/ui/components/VibrationTest.vue';
import { usePaymentStore } from '@/entities/Payment/model/paymentStore';
import { useRouter } from 'vue-router';
import { getVersionInfo } from '@/shared/utils/version/getAppVersion';
import { useModal } from '@/shared/lib/modal/useModal';
import { useAuth } from '@/shared/lib/auth/useAuth';
import CircleSmall from '@/assets/icons/thunder-small.svg'
import CircleMedium from '@/assets/icons/thunder-meduim.svg'
import CircleBig from '@/assets/icons/thunder-big.svg'
import { TicketRepository } from '@/shared/repositories/TicketRepository';
import { SentryService } from '@/shared/lib/sentry/sentryService';
import { getTelegramInitData } from '@/shared/lib/auth/telegramAuth';

const userStore = useUserStore()
const subscriptionStore = useSubscriptionStore()
const paymentStore = usePaymentStore()
const router = useRouter()
const { openPurchaseConfirmationModal, closeAllModals, openReferralModal, openSupportTicketModal, openChangePasswordModal, openSetCredentialsModal } = useModal()
const { logout } = useAuth()

// Показываем тестовый компонент во всех окружениях, кроме local
const isDev = computed(() => import.meta.env.VITE_SENTRY_ENVIRONMENT !== 'local_development')

const isTelegramApp = computed(() => {
  const tg = (window as any).Telegram?.WebApp
  if (!tg) {
    return false
  }

  const { initData } = getTelegramInitData()
  return Boolean(initData && initData.length > 0)
})
const shouldShowBrowserAuthActions = computed(() => !isTelegramApp.value)
const shouldShowTelegramSecurityCta = computed(() => isTelegramApp.value && !userStore.user?.has_credentials)

// Отладочная информация окружения
const envDebug = reactive({
  VITE_SENTRY_ENABLED: import.meta.env.VITE_SENTRY_ENABLED,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  MODE: import.meta.env.MODE,
  DEV: import.meta.env.DEV,
  PROD: import.meta.env.PROD
})

// Информация о версии приложения
const versionInfo = getVersionInfo()

const minPriceValue = computed(() => {
    if(paymentStore.tariffs.length) {
        return Math.min(...paymentStore.tariffs.map(tariff => tariff.price))
    }
    return null
})

const currentOS = computed(() => {
    return detectOS()
})

// Общее состояние загрузки
const isDataLoading = computed(() => {
    return subscriptionStore.isLoading || userStore.isLoading || state.isLoading
})

// Computed для правильного отображения трафика
const displayTraffic = computed(() => {
    const subscription = state.subscription
    
    // Если нет подписки или идет загрузка, не показываем трафик
    if (!subscription || !Object.keys(subscription).length || isDataLoading.value) {
        return ''
    }
    
    // Если lifetime_used_traffic отсутствует, null, undefined или NaN
    const traffic = subscription.lifetime_used_traffic
    if (traffic === null || traffic === undefined || String(traffic) === 'NaN') {
        return ''
    }
    
    // Возвращаем отформатированный трафик
    return ` • ${parseTraffic(traffic)}`
})

interface State {
  user: ComputedRef<UserInfo | null> | null,
  isLoading: boolean,
  subscription: ComputedRef<Subscription | null>,
}

const state = reactive<State>({
  user: computed(() => userStore.user),
  isLoading: false,
  subscription: computed(() => subscriptionStore.subscription)
})

// Функция для обновления данных
async function refreshUserData() {
  try {
    state.isLoading = true
    
    // Обновляем данные пользователя и подписки параллельно
    await Promise.all([
      userStore.fetchUserInfo(),
      subscriptionStore.fetchSubscription()
    ])
    
    console.log('Данные пользователя и подписки обновлены после оплаты')
  } catch (error) {
    console.error('Ошибка при обновлении данных:', error)
  } finally {
    state.isLoading = false
  }
}

function goToPayment() {
  console.log('🏠 HomePage: goToPayment called')
  
  // Отправляем отчет в Sentry
  SentryService.trackButtonClick('Купить подписку', {
    has_subscriptions: subscriptionStore.hasExtraSubscriptions || subscriptionStore.subscriptions.length > 0 || !!subscriptionStore.subscription?.id,
    subscriptions_count: subscriptionStore.subscriptions.length,
    current_subscription_id: subscriptionStore.subscription?.id || null,
    user_balance: userStore.user?.balance || 0
  })
  
  console.log('🏠 Subscription state:', {
    hasExtraSubscriptions: subscriptionStore.hasExtraSubscriptions,
    subscriptionsLength: subscriptionStore.subscriptions.length,
    subscriptions: subscriptionStore.subscriptions,
    subscription: subscriptionStore.subscription
  })
  
  // Проверяем, есть ли у пользователя подписки
  const hasAnySubscriptions = subscriptionStore.hasExtraSubscriptions || 
                             subscriptionStore.subscriptions.length > 0 || 
                             !!subscriptionStore.subscription?.id
  
  console.log('🏠 hasAnySubscriptions:', hasAnySubscriptions)
  
  if (hasAnySubscriptions) {
    console.log('🏠 Есть подписки - показываем модальное окно выбора')
    // Есть подписки - показываем модальное окно с выбором
    openPurchaseConfirmationModal({
      onNewSubscription: () => {
        console.log('🏠 Выбрана новая подписка')
        // Отправляем отчет о выборе новой подписки
        SentryService.trackUserAction('Выбрана новая подписка', {
          has_existing_subscriptions: true,
          action: 'new_subscription_selected'
        })
        
        // Покупка новой подписки - переходим к выбору сервера
        closeAllModals()
        sessionStorage.setItem('purchaseType', 'new')
        sessionStorage.setItem('cameFromHome', 'true')
        router.push('/payment')
      },
      onExtendSubscription: () => {
        console.log('🏠 Выбрано продление подписки')
        // Отправляем отчет о выборе продления
        SentryService.trackUserAction('Выбрано продление подписки', {
          has_existing_subscriptions: true,
          action: 'extend_subscription_selected'
        })
        
        // Продление существующей - переходим на страницу с подписками для выбора
        closeAllModals()
        
        // Устанавливаем флаг, что пользователь пришел для продления
        sessionStorage.setItem('isExtensionFlow', 'true')
        
        router.push('/my-subscriptions')
      }
    })
  } else {
    console.log('🏠 Нет подписок - переходим к покупке новой')
    // Отправляем отчет о покупке первой подписки
    SentryService.trackUserAction('Покупка первой подписки', {
      has_existing_subscriptions: false,
      action: 'first_subscription_purchase'
    })
    
    // Нет подписок - сразу переходим к покупке новой
    sessionStorage.setItem('purchaseType', 'new')
    sessionStorage.setItem('cameFromHome', 'true')
    router.push('/payment')
  }
}

onMounted(async () => {
  // Отправляем отчет о просмотре главной страницы
  SentryService.trackPageView('Главная страница', {
    has_subscription: !!state.subscription?.id,
    subscription_active: state.subscription?.is_active || false,
    user_balance: userStore.user?.balance || 0,
    subscriptions_count: subscriptionStore.subscriptions.length
  })
  
  // Проверяем, нужно ли обновить данные после оплаты
  const shouldRefreshData = sessionStorage.getItem('refreshDataOnHome')
  
  if (shouldRefreshData) {
    // Очищаем флаг и обновляем данные
    sessionStorage.removeItem('refreshDataOnHome')
    await refreshUserData()
  }
  
  // Загружаем тарифы для отображения минимальной цены
  // await paymentStore.fetchTariffs()
})

// Также обновляем данные при возврате на страницу (через keep-alive или navigation)
onActivated(async () => {
  const shouldRefreshData = sessionStorage.getItem('refreshDataOnHome')
  
  if (shouldRefreshData) {
    sessionStorage.removeItem('refreshDataOnHome')
    await refreshUserData()
  }
})

const toMySubscription = () => {
  SentryService.trackButtonClick('Мои подписки', {
    has_subscription: !!state.subscription?.id,
    subscription_id: state.subscription?.id || null
  })
  router.push('/my-subscription')
}

const goToSetup = () => {
  console.log('⚙️ HomePage: goToSetup called')
  
  // Отправляем отчет в Sentry
  SentryService.trackButtonClick('Установка и настройка', {
    has_subscription: !!state.subscription?.id,
    subscription_id: state.subscription?.id || null,
    subscription_active: state.subscription?.is_active || false,
    server_protocol: state.subscription?.server?.protocol || null
  })
  
  // Переходим на страницу установки с ID текущей подписки
  const subscriptionId = state.subscription?.id
  if (subscriptionId) {
    router.push(`/setup/${subscriptionId}`)
  } else {
    console.warn('⚠️ Нет активной подписки для настройки')
    SentryService.captureMessage('Попытка перехода к настройке без активной подписки', 'warning')
    router.push('/setup')
  }
}

const toMySubscriptions = () => {
  SentryService.trackButtonClick('Мои подписки (список)', {
    subscriptions_count: subscriptionStore.subscriptions.length,
    has_extra_subscriptions: subscriptionStore.hasExtraSubscriptions
  })
  router.push('/my-subscriptions')
}

const openReferral = () => {
  SentryService.trackButtonClick('Реферальная программа', {
    user_balance: userStore.user?.balance || 0
  })
  openReferralModal()
}

const openCredentialsSetup = () => {
  SentryService.trackButtonClick('Установить логин и пароль', {
    has_credentials: userStore.user?.has_credentials ?? null,
    isTelegram: isTelegramApp.value
  })
  openSetCredentialsModal({
    onClose: () => {
      SentryService.trackModalClose('Установка логина и пароля')
    }
  })
}

const createSupportTicket = () => {
  SentryService.trackButtonClick('Поддержка', {
    has_subscription: !!state.subscription?.id,
    subscription_active: state.subscription?.is_active || false
  })
  
  openSupportTicketModal({
    onSubmit: async (message: string) => {
      try {
        // Отправляем отчет о создании тикета
        SentryService.trackUserAction('Создание тикета в поддержку', {
          message_length: message.length,
          has_subscription: !!state.subscription?.id
        })
        
        await TicketRepository.createTicket({ text: message });
        // Можно добавить уведомление об успешной отправке
        alert('Запрос в поддержку отправлен!');
        closeAllModals();
      } catch (error) {
        console.error('Ошибка при создании тикета:', error);
        // Отправляем ошибку в Sentry
        SentryService.trackError(error as Error, {
          action: 'create_support_ticket',
          message_length: message.length
        }, 'Создание тикета в поддержку')
        alert('Не удалось отправить запрос в поддержку.');
      }
    },
    onClose: () => {
      console.log('Модальное окно поддержки закрыто');
      SentryService.trackModalClose('Поддержка')
    }
  });
}

const openPasswordChange = () => {
  openChangePasswordModal()
}

const handleLogout = () => {
  logout()
  closeAllModals()
  router.push('/')
}
</script>

<style lang="scss">
.home-page {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow-y: hidden;
    overflow-x: hidden;
    box-sizing: border-box;
    padding-bottom: calc(var(--tg-safe-area-inset-bottom, 0px) + 12px);
    
    &__loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: var(--tg-viewport-height, var(--app-viewport-height, 100dvh));
        width: 100%;
    }

    &-wrapper {
        max-width: 350px;
        height: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        padding-bottom: calc(var(--tg-safe-area-inset-bottom, 0px) + 12px);
    }

    &__logo {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 250px;
        height: 220px;
        // width: 100%;
        margin: 0 auto;
        margin-top: 53px;
        position: relative;
      // Прозрачные анимированные круги могут перекрывать нижние кнопки — отключаем обработку событий
      pointer-events: none;

      * {
        pointer-events: none;
      }

        &-main {
          position: relative;
          z-index: 1;
        }

        &-circle-small {
          position: absolute;
          animation: pulse--circle-small 4.8s linear infinite;
          animation-delay: 0s;
        }

        &-circle-medium {
          position: absolute;
          animation: pulse--circle-medium 4.8s linear infinite;
          animation-delay: 0s;
        }

        &-circle-big {
          position: absolute;
          animation: pulse--circle-big 4.8s linear infinite;
          animation-delay: 0s;
        }
        
    }

    &__security-banner {
        display: flex;
        align-items: center;
        gap: 12px;
        margin: 12px 0 4px;
        padding: 12px 14px;
        border-radius: 14px;
        background: linear-gradient(135deg, #ffb347 0%, #ffcc33 100%);
        box-shadow: 0 10px 30px rgba(255, 179, 71, 0.35);
        color: #1a1a1a;
        cursor: pointer;
        border: none;
        outline: none;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        margin-bottom: 10px;

        &:hover,
        &:focus {
            transform: translateY(-2px);
            box-shadow: 0 14px 34px rgba(255, 179, 71, 0.45);
        }

        &:focus-visible {
            box-shadow:
                0 0 0 2px rgba(26, 26, 26, 0.6),
                0 0 0 4px rgba(255, 204, 51, 0.9);
        }
    }

    &__security-banner-icon {
        font-size: 20px;
        line-height: 1;
    }

    &__security-banner-texts {
        display: flex;
        flex-direction: column;
        gap: 1px;
        flex: 1;
    }

    &__security-banner-title {
        @include p2-medium;
    }

    &__security-banner-subtitle {
        @include p2-regular;
    }

    &__security-banner-action {
        @include p2-medium;
        background: rgba(26, 26, 26, 0.12);
        border-radius: 999px;
        padding: 5px 12px;
        white-space: nowrap;
    }

    .user-block {
        color: $neutral-100;
        @include h1;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &__row {
            flex-basis: 50%;
        }

        .name-traffic {
            display: flex;
            flex-direction: column;

            &__traffic {
                color: $primary-100;
                @include p1-regular;
                margin-top: 8px;
            }
        }

        .expired-subtitle {
            display: flex;
            flex-direction: column;
            align-items: end;
            
            &__expired {
              font-size: 14px;
            }

            &__subtitle {
                color: $primary-100;
                @include p1-regular;
                margin-top: 8px;
            }
        }
    }
}

.menu-home-page {
    display: flex;
    flex-direction: column;
    gap: 16px;
    
    &__wallet {
        margin-top: 28px;
        width: 100%;
        display: flex;
        height: 48px;
    }
    
    &__setup,
    &__referral {
        width: 100%;
        display: flex;
        height: 48px;
    }
    
    &__bottom-row {
        display: flex;
        gap: 8px;
        height: 48px;
    }
    
    &__subscription,
    &__support {
        flex: 1;
        display: flex;
        height: 48px;
    }

    &__auth-row {
        display: flex;
        height: 48px;

        > *:not(:last-child) {
            margin-right: 8px;
        }
    }

    &__password,
    &__logout {
        flex: 1;
        display: flex;
        height: 48px;

        .button-base-block {
            width: 100%;
            height: 100%;
        }

        .button-base {
            height: 100%;
        }
    }
}

// Адаптация под Telegram Desktop (Windows): уменьшаем вертикальные отступы, чтобы влезали нижние кнопки
.tg-platform-tdesktop {
  .home-page {
    padding-bottom: calc(var(--tg-safe-area-inset-bottom, 0px) + 8px);
  }

  .home-page__logo {
    height: 180px;
    margin-top: 24px;
  }

  .menu-home-page {
    gap: 12px;

    &__wallet {
      margin-top: 16px;
    }

    &__bottom-row {
      margin-bottom: 4px;
    }
  }
}

.home-page--with-banner {
    .home-page__logo {
        margin-top: 20px;
    }

    .menu-home-page {
        gap: 12px;
    }

    .menu-home-page__wallet {
        margin-top: 12px;
    }
}

.debug-info {
    position: fixed;
    top: 10px;
    right: 10px;
    max-width: 400px;
    background: rgba(0, 0, 0, 0.9);
    color: white;
    padding: 15px;
    border-radius: 8px;
    font-size: 12px;
    z-index: 9999;
        max-height: calc(var(--tg-viewport-height, var(--app-viewport-height, 100dvh)) * 0.8);
    overflow-y: auto;
}

.version-info {
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    
    h4 {
        margin: 0;
        color: #00ff88;
        font-size: 14px;
    }
}

.env-debug {
    margin-bottom: 15px;
    
    h4 {
        margin: 0 0 10px 0;
        color: #ffd700;
    }
    
    p {
        margin: 5px 0;
        word-break: break-all;
    }
}

@keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 0;
    }
    22.9% { /* 1.1s из 4.8s */
      opacity: 1;
    }
    45.8% { /* 2.2s из 4.8s - конец анимации главного логотипа */
      transform: scale(1.6);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
}

@keyframes pulse--circle-small {
    0% {
      transform: scale(1);
      opacity: 0;
    }
    45.8% { /* 2.2s из 4.8s - начало анимации маленького круга */
      transform: scale(1);
      opacity: 0;
    }
    63.5% { /* 3.05s из 4.8s - середина анимации маленького круга */
      opacity: 1;
    }
    81.3% { /* 3.9s из 4.8s - конец анимации маленького круга */
      transform: scale(1.3);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
}

@keyframes pulse--circle-medium {
    0% {
      transform: scale(1);
      opacity: 0;
    }
    63.5% { /* 3.05s из 4.8s - начало анимации среднего круга (во время пика small) */
      transform: scale(1);
      opacity: 0;
    }
    81.3% { /* 3.9s из 4.8s - середина анимации среднего круга */
      opacity: 1;
    }
    99% { /* 4.75s из 4.8s - конец анимации среднего круга */
      transform: scale(1.5);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
}

@keyframes pulse--circle-big {
    0% {
      transform: scale(1);
      opacity: 0;
    }
    81.3% { /* 3.9s из 4.8s - начало анимации большого круга (во время пика medium) */
      transform: scale(1);
      opacity: 0;
    }
    99% { /* 4.75s из 4.8s - середина анимации большого круга */
      opacity: 1;
    }
    100% { /* 4.8s - конец анимации большого круга */
      transform: scale(1.8);
      opacity: 0;
    }
}
</style>